export default {
  props: {
    niTheme: null,
  },
  data() {
    return {
      current_theme:"light",
      theme: {
        dark: {
          bgColor: "#121212",
          fontColor: "#cecece",
          panelColor: "#FCFCFC",//面板背景色
          inputColor: "#FDFDFE",//输入框背景色

        },
        light: {
          bgColor: "#f2f2f2",
          fontColor: "#333",
          panelColor: "#FCFCFC",//面板背景色
          inputColor: "#FDFDFE",//输入框背景色
        }
      }
    }
  },
  methods: {
    /**
     在body 标签里面 设置--bgColor:#fff 样式,然后各个组件去取
     **/
    setProjectTheme(theme = "light") {
      let body_style = document.getElementsByTagName("body")[0].style
      let theme_data = this.theme[theme]

      for (let item in theme_data) {
        body_style.setProperty("--" + item, theme_data[item])
      }
    },
    /*
        * 获取当前主题
        */
    getProjectTheme() {
      return this.current_theme
    },
    /*
        * 保存用户设置的主题
        */
    saveProjectTheme(theme) {

    },
    /*
        * 设置用户主题
        */
    setCurrentTheme(theme) {
      if (!theme) {
        theme = this.getProjectTheme()
      }

      this.setProjectTheme(theme)
    },
  },


}



// WEBPACK FOOTER //
// ./src/ni-theme/mixin/theme.js